import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FiscalComponent } from './cards/fiscal/fiscal.component';
import { NoticiaComponent } from './noticias/noticia/noticia.component';
import { TrabalhistaComponent } from './cards/trabalhista/trabalhista.component';
import { FinancasComponent } from './cards/financas/financas.component';
import { HttpClientModule } from '@angular/common/http';
import { LegalComponent } from './cards/legal/legal.component';
import { GeralComponent } from './cards/geral/geral.component';


@NgModule({
  declarations: [
    AppComponent,
    FiscalComponent, NoticiaComponent, TrabalhistaComponent, FinancasComponent, LegalComponent, GeralComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
